import { render, staticRenderFns } from "./TermsFormStartup.vue?vue&type=template&id=d04cdd18&"
import script from "./TermsFormStartup.vue?vue&type=script&lang=js&"
export * from "./TermsFormStartup.vue?vue&type=script&lang=js&"
import style0 from "./TermsFormStartup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports